import React, { useState } from 'react';
import { ComposableMap, Geographies, Geography } from "react-simple-maps";
import { scaleSequential } from "d3-scale";
import { interpolateYlGnBu, interpolateBlues } from "d3-scale-chromatic";

const SimpleMapChart = ({ data, width=600, height=600 }) => {
  const [tooltipContent, setTooltipContent] = useState("");

  const colorScale = scaleSequential(interpolateBlues)
    .domain([0, 10]);

  return (
    <>
      <ComposableMap
        projection="geoMercator"
        height={height}
        width={width}
        projectionConfig={{
          scale: 100,
        }}
      >
        <Geographies geography="../../../features.json">
          {({ geographies }) =>
            geographies.map((geo) => {
              const d = data.find((s) => s.id === geo.id);
              return (
                <Geography
                  key={geo.rsmKey}
                  geography={geo}
                  fill={d ? colorScale(d.value) : "#F5F4F6"}
                  stroke="#D6D6DA"
                  onMouseEnter={() => {
                    const { NAME } = geo.properties;
                    setTooltipContent(`${NAME} — ${d ? d.value : "No Data"}`);
                  }}
                  onMouseLeave={() => {
                    setTooltipContent("");
                  }}
                  style={{
                    default: {
                      outline: "none",
                    },
                    hover: {
                      fill: "#2a4858",
                      outline: "none",
                    },
                    pressed: {
                      outline: "none",
                    },
                  }}
                  data-tip=""
                />
              );
            })
          }
        </Geographies>
      </ComposableMap>
    </>
  );
};

export default SimpleMapChart;
